module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/4/2-fcccced6fb8a9b0ca324e42acd15bbb7.jpg";